import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'acc-card-header',
    imports: [],
    templateUrl: './card-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './card-header.component.css'
})
export class CardHeaderComponent {

  @Input()
  public size: 'sm' | undefined;
}
